import styled from 'styled-components';

export const Container = styled('div')`
    padding: 10px 0;
    cursor: pointer;
    border-top: 1px solid ${(props) => props.theme.colors.diviserColor};

    &.dark {
      border-top: 1px solid ${(props) => props.theme.colors.diviserSmoothColor};
    }

    &:first-child {
      border-top: 0px;
    }

    .option-label{
      display: block;
      color: #6c6c6c;
      cursor: pointer;
      width:100%;
      height:100%;

      display: flex;
      flex-direction: row;
      align-items: center;

      font-weight: 300;

      .option-label-content {
        flex: 1;
      }

      @media (max-width: 586px) {
        .option-label-content {
          font-size:14px;
        }
      }
    }

`;
